<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="grey">Make Ebay Order</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h2>Add Ebay Order</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field
            v-model="ebayItem"
            label="Item"
            prepend-icon="class"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="ebayModel"
            label="Model"
            prepend-icon="commute"
            disabled
          ></v-text-field>
          <v-text-field
            v-model="ebayRef"
            label="Ebay Ref"
            prepend-icon="verified_user"
            :rules="inputRules"
          ></v-text-field>
          <v-text-field
            v-model="email"
            label="Email"
            prepend-icon="email"
          ></v-text-field>
          <v-textarea
            v-model="address"
            label="Address"
            prepend-icon="edit"
            :rules="inputRules"
          ></v-textarea>
          <v-spacer></v-spacer>

          <v-btn
            @click="submitAddOrder"
            class="success mx-1 mt-3"
            :loading="loading"
            >Add Order</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    ebayItem: {
      type: String
    },
    ebayModel: {
      type: String
    }
  },
  data() {
    return {
      cartId: "",
      ebayRef: "",
      email: "",
      address: "",
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 3 || "Minimum length is 3 characters"
      ],
      loading: false,
      dialog: false
    };
  },
  methods: {
    async submitAddOrder() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let postbody = {
          ebayItem: this.ebayItem,
          ebayModel: this.ebayModel,
          address: this.address,
          email: this.email,
          ebayRef: this.ebayRef
        };
        await cartApi.postEbayOrder(postbody);
        this.$toast('Created eBay order');
        this.loading = false;
        this.dialog = false;
      }
    },
  }
};
</script>
